'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector read only field
 *
 * @class
 */

class InspectorLabel extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item js-editor__inspector__label" title="<%- tooltip %>"><%- title %></div>
		`;

		super.render();

	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setTitle(value){
		$('.js-editor__inspector__label', this.$el).val(value);
	}
}
module.exports = InspectorLabel;